<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card class="px-4 py-4">
      <v-card-title>
        Nova Aplicação
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <v-form
        ref="form"
      >
        <v-menu
          ref="menu"
          v-model="date_application_menu"
          :close-on-content-click="false"
          transition="scale-transition"
          :state="true"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="date_application"
              label="Data da aplicação"
              prepend-icon="mdi-calendar"
              :state="true"
              :error-messages="formErrors.date_application"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            ref="picker"
            v-model="date_application"
            :state="true"
            :error-messages="formErrors.date_application"
            min="1990-01-01"
            @change="date_application_menu = false"
          />
        </v-menu>
        <v-menu
          ref="menu"
          v-model="start_menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="starts_time"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="starts_time"
              label="Horário de inicio da aplicação"
              prepend-icon="mdi-clock-time-four-outline"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="start_menu"
            v-model="starts_time"
            format="24hr"
            full-width
            @click:minute="$refs.menu.save(starts_time)"
          />
        </v-menu>
        <v-menu
          ref="menutimeend"
          v-model="end_menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="ends_time"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="ends_time"
              label="Horário Fim da aplicação"
              prepend-icon="mdi-clock-time-four-outline"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="end_menu"
            v-model="ends_time"
            format="24hr"
            full-width
            @click:minute="$refs.menutimeend.save(ends_time)"
          />
        </v-menu>
        <v-autocomplete
          v-model="selectedInstitutions"
          :items="institutions"
          prepend-icon="mdi-home-city-outline"
          label="Instituições"
          item-text="code"
          item-value="id"
          multiple
        >
          <template #item="{ item }">
            {{ item.code }} - {{ item.name }}
          </template>
          <template #selection="{ item, select }">
            <v-chip
              small
              close
              @click="select"
              @click:close="selectedInstitutions.splice(selectedInstitutions.indexOf(item.id), 1)"
            >
              {{ item.code }} - {{ item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-form>
      <div class="d-flex justify-space-between">
        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          fechar
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="onSubmit()"
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import dayjs from '@/dayjs.js'
import utc from 'dayjs/plugin/utc'

export default {
  mixins: [
    handlesServerValidation
  ],

  props: {
    idExam: { type: Number, default: null }
  },

  data: () => ({
    date_application: '',
    date_application_menu: false,
    starts_time: '',
    start_menu: false,
    ends_time: null,
    end_menu: false,
    selectedInstitutions: [],
    institutions: [],
    loading: false
  }),
  async mounted () {
    this.institutions = await this.$api.getSchool()
  },

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      this.loading = true
      dayjs.extend(utc)
      try {
        const data = {
          exam_id: this.idExam,
          institution_ids: this.selectedInstitutions,
          starts_at: dayjs(this.date_application + ' ' + this.starts_time).utc().format('YYYY-MM-DD HH:mm:ss'),
          ends_at: dayjs(this.date_application + ' ' + this.ends_time).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        await this.$api.newApplications(this.idExam, data)
        this.$store.dispatch('setSnackBar', { text: 'Grupo criado com sucesso.' })
        this.$emit('resolve', true)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao tentar criar o Grupo.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },
    dayjs
  }
}
</script>
